<template>
	<div
		:style="styles"
		@click.stop="handleClick"
		class="d-flex justify-content-center align-items-center"
		:class="additionalClasses"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: "OverlayComponent",
	props: {
		position: {
			type: String,
			default: "absolute",
		},
		backdropFilter: String,
		background: String,
		zIndex: {
			type: Number,
			default: 1,
		},
		isTransitioning: {
			type: Boolean,
			default: true,
		},
		transitionSpeed: {
			type: Number,
			default: 250,
		},
		additionalClasses: {
			type: Array,
		},
		top: {
			type: Number,
			default: 0,
		},
		right: {
			type: Number,
			default: 0,
		},
		bottom: {
			type: Number,
			default: 0,
		},
		left: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		styles() {
			return {
				position: this.position,
				background: this.background,
				backdropFilter: this.backdropFilter,
				zIndex: this.zIndex,
				transition: this.isTransitioning
					? `background ${this.transitionSpeed}ms ease-in-out, opacity ${this.transitionSpeed}ms ease-in-out`
					: "",
				top: this.top,
				right: this.right,
				bottom: this.bottom,
				left: this.left,
			}
		},
	},
	methods: {},
}
</script>

<style  scoped>
.overlay {
	display: none;
	width: 100%;
	height: 100%;
	backdrop-filter: blur(4px);
	z-index: 1000;
	position: absolute;
	background: #0d141bc2;
	opacity: 0;
}

.overlay.open {
	opacity: 1;
}
</style>
